module.exports = __webpack_public_path__ + "img/1545625377.6c7d9272.jpg";